import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { AddressbookRecordEmailLabel, AddressbookRecordPhoneLabel, APIAddressbookSearchProperties, PaginatedAPIAddressbookContacts } from "../../core/services";

export interface AddEditFormModel {
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  postal_code: FormControl<string>;
  province: FormControl<string>;
  city: FormControl<string>;
  job_title: FormControl<string>;
  website: FormControl<string>;
  company_name: FormControl<string>;
  country: FormControl<string>;
  address_line: FormControl<string>;
  id: FormControl<number>;
  numbers: FormArray<FormGroup<AddEditNumberFormModel>>;
  emails: FormArray<FormGroup<AddEditEmailFormModel>>;
}

export interface AddEditNumberFormModel {
  number: FormControl<string>;
  label: FormControl<AddressbookRecordPhoneLabel>;
}

export interface AddEditEmailFormModel {
  email: FormControl<string>;
  label: FormControl<AddressbookRecordEmailLabel>;
}

export interface ContactSearchOptions {
  label: ContactSearchLabel;
  icon: string;
}

export interface ContactSearchValue {
  input: string;
  searchProperties: APIAddressbookSearchProperties[];
  countryPhoneCode?: string;
}

export type AddEditNumberFormArray = FormArray<FormGroup<AddEditNumberFormModel>>;
export type AddEditEmailFormArray = FormArray<FormGroup<AddEditEmailFormModel>>;

export enum ContactSearchLabel {
  FULL_NAME = 'fullname',
  PHONE_NUMBER = 'phonenumber'
}

export interface ContactSearchOptions {
  label: ContactSearchLabel;
  icon: string;
}